import { useMutation, useQuery } from "@apollo/client";
import { Dialog, Typography } from "@mui/material";
import {
  GetCurrentUserInfoDocument,
  UpdateOnboardingStatusDocument,
} from "../../generated";
import { Button } from "../Button/Button";
import { ModalHolder, ModalTitle, ModalDes, BtnHolder } from "./style";

const TourURL = process.env.REACT_APP_TOUR_URL;

export const TakeATour = () => {
  const { data, loading } = useQuery(GetCurrentUserInfoDocument);

  const [update] = useMutation(UpdateOnboardingStatusDocument, {
    refetchQueries: [GetCurrentUserInfoDocument],
  });

  const clickHandler = async () => {
    update({
      variables: {
        completed: true,
      },
    }).then((res) => res);
  };

  return (
    <Dialog
      open={data?.currentUser.onboardingCompleted === false && !loading}
      fullWidth
      sx={{
        ".MuiPaper-elevation": {
          width: "100%",
          maxWidth: "700px",
          transform: "translateX(0px)",
          overflowX: "hidden",
        },
      }}
    >
      <ModalHolder>
        <ModalTitle>Welcome to Brighthive!</ModalTitle>

        <ModalDes>
          See how BrightAgent turns your data into insights in minutes.
          <br /> This quick tour shows you exactly how our AI agents work as
          your personal data team.
        </ModalDes>
        <BtnHolder>
          <Button variant="outlined" onClick={() => clickHandler()}>
            Skip
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              window.open(TourURL, "_blank");
              clickHandler();
            }}
          >
            Start Tour
          </Button>
        </BtnHolder>
      </ModalHolder>
    </Dialog>
  );
};
